import * as React from "react";
const SvgFiRrCupStrawSwoosh = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 5h-7.494l.266-2.124A1 1 0 0 1 15.765 2H19a1 1 0 0 0 0-2h-3.235a3.005 3.005 0 0 0-2.977 2.627L12.491 5H2a1 1 0 0 0 0 2h.611l1.486 12.586A5 5 0 0 0 9.063 24h5.875a5 5 0 0 0 4.965-4.414L21.389 7H22a1 1 0 0 0 0-2m-7.062 17H9.063a3 3 0 0 1-2.979-2.648L5.62 15.42c.838-.574 2.303-1.419 3.381-1.419.764 0 1.633.435 2.553.895 1.087.543 2.211 1.105 3.447 1.105 1.194 0 2.462-.544 3.442-1.096l-.525 4.448a3 3 0 0 1-2.979 2.648zm3.809-9.681C18.048 12.846 16.259 14 15 14c-.764 0-1.633-.435-2.553-.895C11.36 12.562 10.236 12 9 12c-1.277 0-2.639.623-3.642 1.211L4.625 7h14.75z"
    />
  </svg>
);
export default SvgFiRrCupStrawSwoosh;
